export default __webpack_public_path__ + "b12cc7259c2efbc3c90143878376b57d.png";